import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import {updateValues} from '../../routers/data'
import {fetchCalc} from '../../routers/settings'
import {hideMessage, errorLoad} from '../../routers/messages'

import PropTypes from 'prop-types';

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import SecondHeader from '../components/secondHeader'
import DialogError from '../components/dialogError'
import SelectionTravels from './components/selectionTravels'
import Footer from '../components/footer'

class routeSearch extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  isMobileDevice = () => {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }

  handleClose = () => {
    this.props.hideMessage()
  };


  onCheck = async (value) => {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].search

    const {offer, nAdults, nTeens, nKids, nBabies} = this.props.data.values
    const nPass = nAdults + nTeens + nKids + nBabies
    if (nPass > 5){
      this.props.errorLoad(langPlace.promomessage)
    } else{
      if (offer !== value){
        await this.props.updateValues({offer: value})
      } else {
        await this.props.updateValues({offer: undefined})
      }
      this.props.fetchCalc(this.props.data, this.props.settings)
    }
  }

  onClickDepartureTravel = (value) =>{
    this.props.updateValues({'departuretravel': value})
  }

  onClickReturnTravel = (value) =>{
    this.props.updateValues({'returntravel': value})
  }

  onClickNext = (evt) => {
    const lang = this.context.router.route.location.pathname.split('/')[1]
    this.context.router.history.push(`/${lang}/data`);
    window.scrollTo(0, 0)
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages, promos } = this.props.settings
    const langPlace = languages[langUrl].search

    const {available, calcDeparture, calcReturn} = this.props.settings
    const {travel} = this.props.data.values
    const {nAdults, nTeens, nKids, nBabies} = this.props.data.values
    const {nCars, nMotorcycles, nVans, nTowing, nBikes} = this.props.data.values
    const {departuredate, returndate} = this.props.data.values
    const {departuretravel, returntravel, offer} = this.props.data.values

    const nPass = nAdults + nTeens + nKids + nBabies
    const nVeh = nCars + nMotorcycles + nVans + nTowing + nBikes

    let departures,returns = [] //listDeparture(origin, destiny)

    if (available !== undefined){
        if (available.departures !== undefined){
          departures = available.departures
        }
        if (available.returns !== undefined){
          returns = available.returns
        }
    }
    let isMobile;
    if (this.isMobileDevice() === true ) {
      isMobile = <SecondHeader step={0} travel={travel} langPlace={langPlace} promos={promos} offer={offer} onCheck={this.onCheck} mobile={true} />;
    }
    else {
      isMobile = <SecondHeader step={0} travel={travel} langPlace={langPlace} promos={promos} offer={offer} onCheck={this.onCheck} mobile={false} />
    }

    if (nPass){
      return (
        <div>
          <FirstHeader />
          <Header />
          <div className='container-fluid route-search'>
            <DialogError messages={this.props.messages} handleClose={this.handleClose} />

            {isMobile}
            <div className="second-header-placeholder"></div>

            <div className="row">
              <div className="container">
                <div className="flex-row ">
                    <div className='col-md-12 col-sm-12 col-xs-12'>
                      <div className='row'>
                        <SelectionTravels title={langPlace.going} date={departuredate} list={departures} prices={calcDeparture}
                                          nPassangers={nPass} nVehicles={nVeh} travel={0}
                                          select={departuretravel}
                                          onClickTravel={this.onClickDepartureTravel}/>
                        {(travel === 0)?
                          <SelectionTravels title={langPlace.return} date={returndate} list={returns}  prices={calcReturn}
                                            nPassangers={nPass} nVehicles={nVeh} travel={1}
                                            select={returntravel}
                                            onClickTravel={this.onClickReturnTravel}/>
                        :''}
                      </div>
                      <div className='row separating-line margin-top-50'><hr/></div>
                      <div className='row'>
                        <div className='col-lg-8 col-md-8 col-sm-7 col-xs-6'/>
                        <div className='col-lg-4 col-md-4 col-sm-5 col-xs-12 no-padding'>
                          <div className='general-button button-next' onClick={this.onClickNext}>
                            {langPlace.confirm}<i className="fa fa-angle-right" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      );
    } else {
      return (<Redirect to={`/${langUrl}`} />);
    }
  }
}

export default connect(
	(state) => ({settings: state.settings, data: state.data, messages: state.messages}),
  {updateValues, fetchCalc, errorLoad, hideMessage}
)(routeSearch)



// WEBPACK FOOTER //
// ./src/shared/routes/routeSearch/index.js